import { render, staticRenderFns } from "./ConsultasTabMain.vue?vue&type=template&id=18f5470e&scoped=true&"
import script from "./ConsultasTabMain.vue?vue&type=script&lang=js&"
export * from "./ConsultasTabMain.vue?vue&type=script&lang=js&"
import style1 from "./ConsultasTabMain.vue?vue&type=style&index=1&id=18f5470e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f5470e",
  null
  
)

export default component.exports